import { ReactSVG } from 'react-svg';
import './style.sass';
import { useEffect, useState } from 'react';
import copyIcon from 'assets/img/icons/copyIcon.svg';
import { useBreakpointType } from 'app/services/breakpoints';

type Props = {
    onClick: () => void,
    popupPosition?: 'left' | 'right',
};

export const CopyButton = ({ onClick, popupPosition = 'left' }: Props) => {
    const { isDesktop } = useBreakpointType();

    return (
        isDesktop
            ? <CopyButtonDesktop onClick={onClick} popupPosition={popupPosition}/>
            : <CopyButtonResponsive onClick={onClick}/>
    );
};


const CopyButtonDesktop = ({ onClick, popupPosition }: Props) => {
    const [isCopied, setIsCopied] = useState(false);

    const onClickCopy = () => {
        onClick();
        setIsCopied(true);
    };

    const copyBtnPopupTitle = isCopied ? 'Link copied' : 'Click to copy';

    useEffect(() => {
        if (isCopied) {
            setTimeout(() => { setIsCopied(false); }, 2500);
        }
    }, [isCopied]);

    return (
        <div className="copy-btn" onClick={onClickCopy}>
            <ReactSVG src={copyIcon}/>

            <div className={`copy-btn__popup p2-medium dark-violet ${popupPosition}`}>
                {copyBtnPopupTitle}
            </div>
        </div>
    );
};

const CopyButtonResponsive = ({ onClick }: Props) => {
    const onClickCopy = () => {
        onClick();
    };

    return (
        <div className="copy-btn" onClick={onClickCopy}>
            <ReactSVG src={copyIcon}/>
        </div>
    );
};
